import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';

declare var aisNative: any;

@Component({
  standalone: false,
  selector: 'mc-navigation-bar-item',
  templateUrl: './navigation-bar-item.component.html',
  styleUrls: ['./navigation-bar-item.component.scss']
})

export class NavigationBarItemComponent implements OnInit {
  private _icon!: string;
  private _icons!: string[];
  private _href!: string;
  private _extraParams!: any;
  private _url!: string;
  private _useOtherURL: boolean = false;
  private _isHome: boolean = false;
  private _isBase: boolean = false;
  private _goBack: boolean = false;
  private _notificationIcon: boolean = false;
  private _notificationCount!: number;
  private _notificationCompare: boolean = false;
  private mobileNo: any;

  ngOnInit(): void { /**/ }

  @Input()
  get icon(): string {
    return this._icon;
  }
  set icon(icon: string) {
    this._icon = "assets/images/icon/" + icon;
  }

  @Input()
  get icons(): string[] {
    return this._icons;
  }
  set icons(icons: string[]) {
    this._icons = icons;
  }

  @Input()
  get href(): string {
    return this._href;
  }
  set href(href: string) {
    this._href = href;
  }

  @Input()
  get extraParams(): string {
    return this._extraParams;
  }
  set extraParams(extraParams: string) {
    this._extraParams = extraParams;
  }

  @Input()
  get url(): string {
    return this._url;
  }
  set url(url: string) {
    this._url = url;
  }

  @Input()
  get useOtherURL(): boolean {
    return this._useOtherURL;
  }
  set useOtherURL(useOtherURL: boolean) {
    this._useOtherURL = useOtherURL;
  }

  @Input()
  get isHome(): boolean {
    return this._isHome;
  }
  set isHome(isHome: boolean) {
    this._isHome = isHome;
  }

  @Input()
  get isBase(): boolean {
    return this._isBase;
  }
  set isBase(isBase: boolean) {
    this._isBase = isBase;
  }

}
